import LexiconStem, { LexiconStemProps } from "./LexiconStem";

interface LexiconStemMatchProps extends LexiconStemProps {
    isSimpleMatch: boolean;
}

export default class LexiconStemMatch extends LexiconStem {

    private simpleMatch: boolean;

    public constructor(props: LexiconStemMatchProps) {
        super(props);
        this.simpleMatch = props.isSimpleMatch;
    }

    public isSimpleMatch(): boolean {
        return this.simpleMatch;
    }
}
